import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  :root {
    /* Color Palette */
    --primary-color: #5c3d2e;
    --secondary-color: #b85c38;
    --accent-color: #e09f3e;
    --light-color: #fff3e4;
    --dark-color: #35281e;
    --gray-color: #f5f5f5;
    --text-color: #333333;
    --text-light: #777777;
    
    /* Typography */
    --heading-font: 'Playfair Display', serif;
    --body-font: 'Poppins', sans-serif;
    
    /* Spacing */
    --section-padding: 80px 0;
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    scroll-behavior: smooth;
  }

  body {
    font-family: var(--body-font);
    font-size: 16px;
    line-height: 1.6;
    color: var(--text-color);
    background-color: #ffffff;
    overflow-x: hidden;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: var(--heading-font);
    font-weight: 700;
    line-height: 1.3;
    margin-bottom: 20px;
    color: var(--dark-color);
  }

  p {
    margin-bottom: 20px;
  }

  a {
    text-decoration: none;
    color: var(--primary-color);
    transition: all 0.3s ease;
  }

  a:hover {
    color: var(--secondary-color);
  }

  ul, ol {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  img {
    max-width: 100%;
    height: auto;
    display: block;
  }

  button {
    cursor: pointer;
    font-family: var(--body-font);
  }

  /* Utility Classes */
  .text-center {
    text-align: center;
  }

  .img-placeholder {
    background-color: #e0e0e0;
    min-height: 100px;
  }
`;

export default GlobalStyles;
